import arSA from './ar-SA/translation.json.js';
import deDE from './de-DE/translation.json.js';
import enUS from './en-US/translation.json.js';
import esES from './es-ES/translation.json.js';
import frCA from './fr-CA/translation.json.js';
import idID from './id-ID/translation.json.js';
import itIT from './it-IT/translation.json.js';
import jaJP from './ja-JP/translation.json.js';
import koKR from './ko-KR/translation.json.js';
import ptBR from './pt-BR/translation.json.js';
import ruRU from './ru-RU/translation.json.js';
import thTH from './th-TH/translation.json.js';
import trTR from './tr-TR/translation.json.js';
import viVN from './vi-VN/translation.json.js';
import zhCN from './zh-CN/translation.json.js';
import zhTW from './zh-TW/translation.json.js';
import dropdownsData from './ar-SA.js';
import dropdownsData$1 from './de-DE.js';
import dropdownsData$2 from './en-US.js';
import dropdownsData$3 from './es-ES.js';
import dropdownsData$4 from './fr-CA.js';
import dropdownsData$5 from './id-ID.js';
import dropdownsData$6 from './it-IT.js';
import dropdownsData$7 from './ja-JP.js';
import dropdownsData$8 from './ko-KR.js';
import dropdownsData$9 from './pt-BR.js';
import dropdownsData$a from './ru-RU.js';
import dropdownsData$b from './th-TH.js';
import dropdownsData$c from './tr-TR.js';
import dropdownsData$d from './vi-VN.js';
import dropdownsData$e from './zh-CN.js';
import dropdownsData$f from './zh-TW.js';

arSA.translation = {
    ...arSA.translation,
    ...dropdownsData,
};
deDE.translation = {
    ...deDE.translation,
    ...dropdownsData$1,
};
enUS.translation = {
    ...enUS.translation,
    ...dropdownsData$2,
};
esES.translation = {
    ...esES.translation,
    ...dropdownsData$3,
};
frCA.translation = {
    ...frCA.translation,
    ...dropdownsData$4,
};
idID.translation = {
    ...idID.translation,
    ...dropdownsData$5,
};
itIT.translation = {
    ...itIT.translation,
    ...dropdownsData$6,
};
jaJP.translation = {
    ...jaJP.translation,
    ...dropdownsData$7,
};
koKR.translation = {
    ...koKR.translation,
    ...dropdownsData$8,
};
ptBR.translation = {
    ...ptBR.translation,
    ...dropdownsData$9,
};
ruRU.translation = {
    ...ruRU.translation,
    ...dropdownsData$a,
};
thTH.translation = {
    ...thTH.translation,
    ...dropdownsData$b,
};
trTR.translation = {
    ...trTR.translation,
    ...dropdownsData$c,
};
viVN.translation = {
    ...viVN.translation,
    ...dropdownsData$d,
};
zhCN.translation = {
    ...zhCN.translation,
    ...dropdownsData$e,
};
zhTW.translation = {
    ...zhTW.translation,
    ...dropdownsData$f,
};
const ProfileFormTranslations = {
    "ar-SA": arSA,
    "de-DE": deDE,
    "en-US": enUS,
    "es-ES": esES,
    "fr-CA": frCA,
    "fr-FR": frCA,
    "id-ID": idID,
    "it-IT": itIT,
    "ja-JP": jaJP,
    "ko-KR": koKR,
    "pt-BR": ptBR,
    "ru-RU": ruRU,
    "th-TH": thTH,
    "tr-TR": trTR,
    "vi-VN": viVN,
    "zh-CN": zhCN,
    "zh-TW": zhTW,
};

export { ProfileFormTranslations };
